var styleDataHash = "ae80a9e3";
const injectCss = () => {
  var css = `.veGG-{--wds-tabs-padding-horizontal-medium:12px;--wds-font-size-body-medium:14px;--wds-font-weight-regular:500}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var settings_modal_default = {
  "tabs": "veGG-"
};
export {
  settings_modal_default as default,
  injectCss
};
//# sourceMappingURL=settings-modal-scss.js.map
